import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { StreappReaction } from '../../../models/streappreaction.model';
import { StreappEventsService } from 'src/app/services/streapp-events.service';

@Component({
    selector: 'reaction',
    templateUrl: './reaction.component.html',
    styleUrls: ['./reaction.component.scss'],
    standalone: false
})
export class ReactionComponent implements OnInit {
  @Input() items: Array<StreappReaction>;
  @Input() loading: boolean;
  @Input() reactionsAllowed: boolean = true;
  @Input() exportAllowed: boolean = false;
  @Input() eventId: string;

  @Output() exportReactions: EventEmitter<void> = new EventEmitter();
  @Output() addReaction: EventEmitter<string> = new EventEmitter();
  @Output() updateReaction: EventEmitter<{ text: string, id: string }> = new EventEmitter();
  @Output() removeReaction: EventEmitter<string> = new EventEmitter();
  @Output() loadMore: EventEmitter<{}> = new EventEmitter();

  user: string;
  editableItem: string;

  profilePictures = new Map<string, string>();

  reactionForm: UntypedFormGroup = new UntypedFormGroup({
    text: new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(1000),
      Validators.minLength(3)
    ])
  });

  reactionReplyForm: UntypedFormGroup = new UntypedFormGroup({
    text: new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(1000),
      Validators.minLength(3)
    ])
  });

  constructor(
    private readonly authService: AuthService,
    private readonly streappService: StreappEventsService
  ) {
  }

  ngOnInit() {
    this.user = this.authService.userId;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items'] && this.items?.length > 0) {
      this.fetchProfilePictures(this.items);
    }
  }

  profileImageUrl(uuid: string): string {
    return '/assets/images/user.png';
  }

  editItem(item: StreappReaction): void {
    this.editableItem = item.partitionKey;
    this.reactionReplyForm.controls.text.setValue(item.content);
  }

  formSubmit(): void {
    this.addReaction.emit(this.reactionForm.controls.text.value);
    this.reactionForm.reset();
  }

  deleteReaction(id: string): void {
    this.removeReaction.emit(id);
    this.editableItem = null;
  }

  addEnter(event): void {
    event.preventDefault();
    this.reactionForm.controls['text'].patchValue(this.reactionForm.controls.text.value + '\n');
  }

  doLoadMore(): void {
    this.loadMore.emit(true);
  }

  export(): void {
    this.exportReactions.emit();
  }

  editReaction(): void {    
    this.updateReaction.emit({ text: this.reactionReplyForm.controls.text.value, id: this.editableItem });
    this.editableItem = null;
  }

  cancelUpdate(): void {
    this.editableItem = null;
  }

  isLoggedIn(): boolean {
    return this.authService.isAuthenticated();
  }

  async fetchProfilePictures(items: any[]): Promise<void> {
    for (const item of items) {
      if (!this.profilePictures.has(item.createdBy)) {
        const pictureUrl = (await this.streappService.getStreapperInfoId(item.createdBy)).picture;
        this.profilePictures.set(item.createdBy, pictureUrl);
      }
    }
  }

  generateLink(reaction: StreappReaction): string {
    return reaction.isReporter ? "/streappers/detail" : "/users/detail";
  }
} 
